module.exports = __webpack_public_path__ + "static/media/bell.67ed96c6.svg";